import React from 'react'

let LoadingPage = () => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
      className="bg-dark"
    >
      <div
        style={{ marginTop: '50px' }}
        className="d-flex align-items-center flex-column"
      >
        {/* <div>
          <img
            src="https://evergreenonlineleads.com/wp-content/uploads/2018/12/LogoWhite.png"
            style={{ height: '25px' }}
            alt=""
          />
        </div> */}

        <div style={{ marginTop: '25px' }}>
          <i className="text-white fa fa-spinner fa-spin fa-2x" />
        </div>
      </div>
    </div>
  )
}

export default LoadingPage
